import React, { useState, useEffect } from "react";
import { Button, Form, Select } from "antd/lib";
import { useDispatch, useSelector } from "react-redux";
import { CustLife_detail } from "../../Redux/actions/NumLife";
import IncomeData from "./IncomeData";

export default function LifeSep2({ setCurrent, current }) {
  console.log(current);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.lifedetail?.cusInfo);
  const [loading, setLoading] = useState(false);
  console.log("CusDeatail", CusDeatail);

  const OnFinish = (values) => {
    console.log(values);
    const UpdateCus = {
      ...CusDeatail,
      Occupation: values?.occupation,
      Education: values?.education,
      Income: values?.income,
      PolicyTerm: values?.policyTerm,
    };
    console.log(UpdateCus);
    dispatch(CustLife_detail(UpdateCus));
    setCurrent(current + 1);
  };

  const validatePolicyTerm = (_, value) => {
    // console.log('value',value)
    // const PTerm = parseInt(value)
    const age = parseInt(CusDeatail?.Age);
    // const selectedAgeGap = PTerm + age;
    // console.log(selectedAgeGap)
    if (age >= 56) {
      return Promise.reject(
        new Error(`Plan Premium not defined for this Plan, Age :${age}.`)
      );
    }

    return Promise.resolve();
  };

  return (
    <>
      <div className="step-container-health d-flex justify-content-center">
        <Form
          layout="vertical"
          form={form}
          style={{ width: "95%" }}
          requiredMark={true}
          onFinish={OnFinish}
        >
          <Form.Item
            name="occupation"
            label="Occupation"
            rules={[
              {
                required: true,
                message: "please select Occupation",
              },
            ]}
            initialValue={CusDeatail?.Occupation}
          >
            <Select
              // onChange={handleChange}
              style={{ textAlign: "left" }}
              placeholder="Occupation"
              options={[
                {
                  value: "Salaried",
                  label: "Salaried",
                },
                {
                  value: "Self Employed",
                  label: "Self Employed",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="education"
            label="Education"
            rules={[
              {
                required: true,
                message: "please select Education",
              },
            ]}
            initialValue={CusDeatail?.Education}
          >
            <Select
              style={{ textAlign: "left" }}
              placeholder="Education"
              options={[
                {
                  value: "Post Graduate",
                  label: "Post Graduate",
                },
                {
                  value: "Graduate",
                  label: "Graduate",
                },
                {
                  value: "12th Pass",
                  label: "12th Pass",
                },
                {
                  value: "10th Pass",
                  label: "10th Pass",
                },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="income"
            label="Annual Income"
            rules={[
              {
                required: true,
                message: "please select Income",
              },
            ]}
            initialValue={CusDeatail?.Income}
          >
            <Select
              style={{ textAlign: "left" }}
              placeholder="Annual Income"
              options={IncomeData?.map((p) => ({
                value: p?.value,
                label: p?.label,
              }))}
            />
          </Form.Item>
          <Form.Item
            name="policyTerm"
            label="Policy Term"
            rules={[
              {
                required: true,
                message: "please select Income",
              },
              {
                validator: validatePolicyTerm,
              },
            ]}
            initialValue={CusDeatail?.PolicyTerm}
          >
            <Select
              style={{ textAlign: "left" }}
              placeholder="Policy Term"
              options={[
                {
                  value: "10",
                  label: "10 Years",
                },
                {
                  value: "12",
                  label: "12 Years",
                },
                {
                  value: "15",
                  label: "15 Years",
                },
              ]}
            />
          </Form.Item>
          <Form.Item>
            <div className="step-btn-health">
              {current && current > 0 ? (
                <Button
                  style={{ width: "40%" }}
                  onClick={() => setCurrent(current - 1)}
                >
                  Back
                </Button>
              ) : null}
              <Button
                loading={loading}
                type="primary"
                htmlType="submit"
                style={{ width: "40%" }}
              >
                Continue
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}
